import { render } from "./ThingsBanner.vue?vue&type=template&id=2dfe2054&scoped=true"
import script from "./ThingsBanner.vue?vue&type=script&lang=js"
export * from "./ThingsBanner.vue?vue&type=script&lang=js"

import "./ThingsBanner.vue?vue&type=style&index=0&id=2dfe2054&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfe2054"]])

export default __exports__